import React from 'react';
import ErrorBoundary from '../containers/ErrorBoundary/ErrorBoundary';

const wrapper = (Wrappedcomponent) => {
    return class extends React.Component {
        render() {
            return (
                <ErrorBoundary>
                    <Wrappedcomponent {...this.props}/>
                </ErrorBoundary>
            )
        }
    }
};

export default wrapper;